<div>
    {{'modelstate.state' | translate}}: {{labeledDataManager.state}}
</div>